import { render, staticRenderFns } from "./LasPalmasPark.vue?vue&type=template&id=1386a606&scoped=true&"
import script from "./LasPalmasPark.vue?vue&type=script&lang=js&"
export * from "./LasPalmasPark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1386a606",
  null
  
)

export default component.exports